import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrambleTextPlugin);

export default class Intro {
    constructor() {
        this.init();
    }

    init() {
        this.introIn();
    }

    introIn() {
        document.body.setAttribute('data-loaded', '1');
        const elm = document.querySelector('.js-mainvisual-logo img');
        const src = `./assets/img/top/mainvisual/ph_logo_anim.png?d=${new Date().getTime()}`; //キャッシュ回避
        elm.src = src;

        const introtxt = document.querySelector('.js-intro_txt');
        introtxt.src = `./assets/img/top/mainvisual/txt_intro.png?d=${new Date().getTime()}`; //キャッシュ回避
        introtxt.onload = () => {
            introtxt.setAttribute('data-active', 1);
        };

        setTimeout(() => {
            this.mvIn();
            this.kvIn();
        }, 2000);
    }

    mvIn() {
        setTimeout(() => {
            this.randomText('show');
        }, 500);

        setTimeout(() => {
            document.body.setAttribute('data-logoanim', '1');
        }, 2500);

        setTimeout(() => {
            document.body.setAttribute('data-mvanim_ended', '1');
            this.randomText('hide');
        }, 4000);

        setTimeout(() => {
            this.setPngLoop();
        }, 6000);
    }

    kvIn(delay = 1500) {
        document.body.setAttribute('data-kvanim', '1');

        setTimeout(() => {
            document.body.setAttribute('data-divideanim', '1');
        }, delay);

        setTimeout(() => {
            document.body.setAttribute('data-glitchanim', '1');
            document.body.removeAttribute('data-kvanim');
            document.body.removeAttribute('data-divideanim');
        }, delay + 1000);

        setTimeout(() => {
            document.body.dataset.endKv = document.body.dataset.startKv;
            document.body.setAttribute('data-kvanim_ended', '1');
            document.body.removeAttribute('data-glitchanim');
        }, delay + 1500);
    }

    randomText(mode) {
        const element = document.querySelectorAll('.js-shuffletxt');
        const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()_+-=[]{}|;:",.<>/?';

        element.forEach(el => {
            el.setAttribute('data-active', '1');
            if (mode === 'show') {
                const originalText = el.textContent;
                gsap.to(el, {
                    duration: 1.4,
                    scrambleText: {
                        text: originalText,
                        chars: randomChars,
                        speed: 1.4,
                    },
                    ease: 'power1.inOut',
                });
            } else if (mode === 'hide') {
                gsap.to(el, {
                    duration: 1.4,
                    scrambleText: {
                        text: '',
                        chars: randomChars,
                        speed: 1.4,
                    },
                    ease: 'power1.inOut',
                });
            }
        });
    }

    setPngLoop() {
        const loop = () => {
            const elm = document.querySelector('.js-mainvisual-logo img');
            const src = `./assets/img/top/mainvisual/ph_logo_anim.png?d=${new Date().getTime()}`;
            elm.src = src;

            setTimeout(loop, 5000);
        };

        loop();
    }
}
